var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.disabled ? "cart-button-disabled" : "cart-button",
      attrs: { type: "button" },
      on: { click: _vm.submitCart },
    },
    [
      _c("span", { staticClass: "cart-button-spacer" }),
      _vm._v(" "),
      _c("span", { staticClass: "cart-button-text" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "cart-button-icon" },
        [
          _c(
            "icon-base",
            { attrs: { width: "22", height: "22", iconName: "Submit Cart" } },
            [_c("icon-bag")],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }